const colors = {
    SYSTEM_ERROR: "system-error",
    SYSTEM_LIGHT: "system-light",
    SYSTEM_WARNING: "system-warning",
    THEME_PRIMARY: "theme-primary",
};

export default colors;
